import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

//Context
import { useAuth } from 'context/auth';

//Component
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//API
import dashboard_api from '../../../api/dashboard_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

export default function GeradoresSemPGRS() {
    const { setLoading } = useAuth();

    const [listGeradoresSemPGRS , setListGeradoresSemPGRS] = useState([]);

    //Cabeçalhos da tabela de listagem de geradores
    const headersTabela = [
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Fantasia", objectValue: "fantasia", align: "left", },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Transportador", objectValue: "transportador", align: "left" },
        { value: "Modalidade de Coleta", objectValue: "modalidadeColeta", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Frequência", objectValue: "frequencia", align: "left" },
        { value: "Quantidade Estimada", objectValue: "quantidadeEstimada", align: "left" },
    ];

    //Variavel para navegação entre telas
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true)
        dashboard_api.GeradoresSemPGRS().then(response => {
            response.data = response.data.map(item => {
                item.cnpj = mascaras.cpfcnpjMask(item.cnpj);
                item.quantidadeEstimada = mascaras.floatMask(item.quantidadeEstimada)
                return item;
            })
            setListGeradoresSemPGRS(response.data);
        }).catch(e => {
            showMessage("Erro", e.message, "error", null);
        }).finally(() => setLoading(false));
    }, [])

    return (
        <MainCard
            title={"Geradores Sem PGRS"}
            btnVoltarInTop={() => navigate(-1)}
            noCard
        >
            <div className={`w-100 `}>
                <div className='mt-4'>
                    <TabelaListagem
                        headers={headersTabela}
                        items={listGeradoresSemPGRS}
                        title="Lista de geradores sem PGRS"
                        options={{ print: false, search: true, pagination: true }}
                    />
                </div>
            </div>
        </MainCard>
    )
}
